// Photo filenames for Queensboro 2010
const QUEENSBORO_2010 = [
  'queensboro-2010-100_16368463189_c.jpg',
  'queensboro-2010-101_16554761005_m.jpg',
  'queensboro-2010-102_16528743656_m.jpg',
  'queensboro-2010-103_15934561073_m.jpg',
  'queensboro-2010-104_16367288950_m.jpg',
  'queensboro-2010-106_16367076048_m.jpg',
  'queensboro-2010-107_16368459289_m.jpg',
  'queensboro-2010-108_15934558513_z.jpg',
  'queensboro-2010-109_16367285630_z.jpg',
  'queensboro-2010-200_16367275510_z.jpg',
  'queensboro-2010-202_16368446869_z.jpg',
  'queensboro-2010-205_16367273890_z.jpg',
  'queensboro-2010-209_15934545733_z.jpg',
  'queensboro-2010-302_16367048848_z.jpg',
  'queensboro-2010-303_15932148434_z.jpg',
  'queensboro-2010-304_16368430989_z.jpg',
  'queensboro-2010-305_15934532493_z.jpg',
  'queensboro-2010-306_16368799157_z.jpg',
  'queensboro-2010-308_16528712676_z.jpg',
  'queensboro-2010-1010_16368456609_z.jpg',
  'queensboro-2010-1011_16368456079_z.jpg',
  'queensboro-2010-1012_16554750395_l.jpg',
  'queensboro-2010-1013_16528733336_l.jpg',
  'queensboro-2010-1014_16368818747_m.jpg',
  'queensboro-2010-2010_16368444099_c.jpg',
  'queensboro-2010-2013_15932160634_z.jpg',
  'queensboro-2010-2014_16368811357_z.jpg',
  'queensboro-2010-2015_16367059088_z.jpg',
  'queensboro-2010-2017_16528724806_m.jpg',
  'queensboro-2010-2018_15934543013_m.jpg',
  'queensboro-2010-2020_16368441679_z.jpg',
  'queensboro-2010-2025_16367057398_z.jpg',
  'queensboro-2010-2027_16553624342_z.jpg',
  'queensboro-2010-2028_16553623632_z.jpg',
  'queensboro-2010-2029_15932156314_z.jpg',
  'queensboro-2010-2030_16553622842_w.jpg',
  'queensboro-2010-2031_16553622592_z.jpg',
  'queensboro-2010-2041_16368429069_z.jpg',
  'queensboro-2010-2042_16367257330_z.jpg',
  'queensboro-2010-2043_16368428649_z.jpg',
  'queensboro-2010-2044_16554728185_z.jpg',
  'queensboro-2010-2046_16553031701_z.jpg',
  'queensboro-2010-2047_16367266610_z.jpg',
  'queensboro-2010-3014_16528707676_l.jpg',
  'queensboro-2010-3015_16368424579_l.jpg',
  'queensboro-2010-3016_16553608912_l.jpg',
  'queensboro-2010-3023_15934526013_z.jpg',
  'queensboro-2010-3026_16553028341_z.jpg',
  'queensboro-2010-3030_16528704716_z.jpg',
  'queensboro-2010-3031_16368790177_z.jpg',
  'queensboro-2010-3040_16367037758_z.jpg',
];

export default QUEENSBORO_2010;
